export default __webpack_public_path__ + "images/logo-kongress.svg?45372b9d37e32f0d9cb16c1a6fed781b";